import { InventoryProvider } from '@scaleaq/sitecontrol-lib';

import { ProviderSensorConfig } from '@/components/ProviderSensorConfig.tsx';
import { ORBIT_ONE_TYPES_SOURCE } from '@/components/widgetConfigSiteTabbedShell/index.ts';
import { WidgetConfigModalProps } from '@/types.ts';

export const LiceCountModalContent = (props: WidgetConfigModalProps) => (
  <ProviderSensorConfig
    provider={InventoryProvider.LiceCountAdultFemale}
    source={ORBIT_ONE_TYPES_SOURCE}
    {...props}
  />
);
